module.exports = __webpack_public_path__ + "static/media/slider-4.8d79da3b.jpg";